import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { PatientSingleSessionItem } from '@uplift/ui-v2';
import { CalendarDateService } from '@uplift/services';

import { useTimezone } from '@uplift/contexts';
import { NextSession } from '@uplift/api';
import { formatUserFullName, getUserFullName } from '@uplift/utils';
import { ModalsEnum, useModalsContext } from '../../../../../app/hooks/modal';


export type NextSessionsProps = {
  nextSessions: NextSession[];
};


const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  }
}));


export const NextSessions: React.FC<NextSessionsProps> = (props) => {
  const modalStore = useModalsContext();
  const timezone = useTimezone();
  const { classes } = useStyles();

  const nextSessions = React.useMemo(() => {
    const now = CalendarDateService.date();

    return props.nextSessions.map(s => {
      const start = CalendarDateService.date(s.fromDatetime).tz(timezone);
      const diff = start.diff(now, 'minutes');

      const providerName = formatUserFullName({
        firstName: s.provider.firstName,
        lastName: s.provider.lastName,
        preferredFirstName: s.provider.preferredName,
      });

      return {
        id: s.id,
        start: start,
        end: CalendarDateService.date(s.toDatetime).tz(timezone),
        isMaterialized: s.isMaterialized,
        providerName,
        providerDisplay: getUserFullName(s.provider.firstName, s.provider.lastName, s.provider.preferredName),
        providerRole: s.provider.medicalRole,
        connectLink: diff < 30 ? `/appointments/${s.id}/session` : null,
        seriesId: s.appointmentSeriesId,
        type: 'single' as const,
        // cancelMode
      };
    });
  }, [ props.nextSessions, timezone ]);

  return (
    <Box className={classes.root}>
      {nextSessions.map(item => (
        <PatientSingleSessionItem
          key={item.id}
          item={item}
          onCancel={() => modalStore.openModal(ModalsEnum.cancelSession, {
            appointment: {
              id: item.id,
              fromDatetime: item.start,
              parentId: item.seriesId,
              isMaterialized: item.isMaterialized,
              providerName: item.providerDisplay,
            },
            cancelMode: 'manual',
          })}
        />
      ))}
    </Box>
  );
};
